import ApiService from "../../api.service";

// Actions
export const GET_MARKING_ADMIN_LIST = "GET_MARKING_ADMIN_LIST";
export const DELETE_MARKING_ADMIN = "DELETE_MARKING_ADMIN";
export const CREATE_MARKING_ADMIN = "CREATE_MARKING_ADMIN";
export const UPDATE_MARKING_ADMIN = "UPDATE_MARKING_ADMIN";
export const GET_EXAM_SHIFTS = "GET_EXAM_SHIFTS";
export const GET_MARK_ALL_ADMIN = "GET_MARK_ALL_ADMIN";
export const GET_DETAIL_EXAM_SHIFTS = "GET_DETAIL_EXAM_SHIFTS";
export const EDIT_EXAM_SHIFTS = "EDIT_EXAM_SHIFTS";
export const TOGGLE_EXAM_SHIFT = "TOGGLE_EXAM_SHIFT";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  [GET_MARKING_ADMIN_LIST](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query("academic/admin", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [CREATE_MARKING_ADMIN](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("academic/admin", payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [UPDATE_MARKING_ADMIN](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("academic/admin/" + payload.id, payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [DELETE_MARKING_ADMIN](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.delete("academic/admin", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_EXAM_SHIFTS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query("academic/marking/exam-shift", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_MARK_ALL_ADMIN](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query("academic/admin/all", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_DETAIL_EXAM_SHIFTS](context, id) {
    return new Promise((resolve) => {
      ApiService.get("academic/marking/exam-shift", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((response) => {
          console.log(response);
        });
    });
  },
  [EDIT_EXAM_SHIFTS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("academic/marking/exam-shift", payload.id, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [TOGGLE_EXAM_SHIFT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.put(`academic/marking/exam-shift/${id}/toggle-status`, {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
